// Telegram Mini App bootstrap. When the app runs inside Telegram's WebView,
// the SDK exposes HMAC-signed initData; the server verifies it and issues the
// regular session cookie, so the user skips the login form entirely.
import { apiPost } from "./api";

// True only for a real Mini App launch (signed initData is present)
export const isTelegramMiniApp = () =>
  Boolean(window.Telegram?.WebApp?.initData);

// True for Telegram's in-app browser as well (site opened from a message
// link without Mini App launch params): the proxy object exists but initData
// is empty. Used to steer install instructions to an external browser.
export const isTelegramWebView = () =>
  Boolean(window.TelegramWebviewProxy) || isTelegramMiniApp();

// Signals the Mini App chrome and exchanges initData for a session cookie.
// Returns the server payload ({status:"success"|"no_account"}) or null when
// not running as a Mini App / the exchange failed — callers render normally.
export const loginViaTelegramMiniApp = async () => {
  if (!isTelegramMiniApp()) return null;
  const webApp = window.Telegram.WebApp;
  try {
    webApp.ready();
    webApp.expand();
  } catch {
    // SDK cosmetics must never block the app
  }
  try {
    return await apiPost("/api/auth/tg-miniapp", { initData: webApp.initData });
  } catch {
    return null;
  }
};
